import type { Value } from '@warp-drive/core/types/json/raw';

/**
 * Extracts the total count from a pagination metadata object.
 *
 * @param page - The pagination metadata object from a JSON:API response
 * @returns The total count, or 0 if not found
 */
export function getPaginationTotal(page: Value): number {
  if (typeof page === 'object' && page !== null && 'total' in page) {
    return page.total as number;
  }
  return 0;
}
